import { useRef } from "react";
import {
  Container,
  ActiveMenu,
  ActivedButtonContainer,
  MenuNone,
  MenuText,
  MenuCheck,
  MenuOption,
  MenuUnmarked,
} from "./styles";
import Filter from "../../../../assets/icons/Filter";
import Check from "../../../../assets/icons/Check";
import Button from "../../../../components/general/Button/index";
import { useOutsideDrop } from "../../../../hooks/useOutsideDrop";

/**
 * @param {Object} props
 * @param {boolean} props.open
 * @param {function(boolean):void} props.setOpen
 * @param {function():void} props.onSelectNone
 * @param {Array<{ value: boolean, label: string, onChange: function }>} [props.options=[]]
 * @returns {JSX.Element}
 */
export const FilterOptionsButton = ({
  open,
  setOpen,
  onSelectNone,
  options = [],
}) => {
  const containerRef = useRef(null);

  useOutsideDrop(containerRef, () => {
    setOpen(false);
  });

  return (
    <>
      {!open ? (
        <Container>
          <Button
            Icon={() => <Filter />}
            onClick={(e) => {
              setOpen(!open);
              e.stopPropagation();
            }}
            content="Filtros"
          />
        </Container>
      ) : (
        <ActivedButtonContainer ref={containerRef}>
          <Button
            colorText="#7e858f"
            Icon={() => <Filter />}
            onClick={() => {
              setOpen(!open);
            }}
            content="Filtros"
            greenBase
          />
          <ActiveMenu>
            <MenuNone onClick={onSelectNone}>
              <MenuText>Nenhum</MenuText>
              <MenuCheck>
                {options.every((option) => !option.value) ? (
                  <Check height={"1rem"} />
                ) : (
                  <MenuUnmarked />
                )}
              </MenuCheck>
            </MenuNone>
            {options.map((option) => (
              <MenuOption onClick={option.onChange}>
                <MenuText>{option.label}</MenuText>
                <MenuCheck>
                  {option.value ? <Check height={"1rem"} /> : <MenuUnmarked />}
                </MenuCheck>
              </MenuOption>
            ))}
          </ActiveMenu>
        </ActivedButtonContainer>
      )}
    </>
  );
};
